import React from "react";
import { FIRM, NAV_LINKS } from "../data/mock";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-navy-deep text-ivory/80 pt-20 pb-8 relative overflow-hidden"
    >
      {/* Gold top divider */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 pb-16">
          {/* Brand column */}
          <div className="lg:col-span-5">
            <div className="bg-ivory/95 inline-block px-5 py-3 rounded-sm">
              <img
                src="https://customer-assets.emergentagent.com/job_legal-finance-3/artifacts/jf349uv5_logo-1.png"
                alt="The Bufkin Law Firm"
                className="h-12 w-auto"
              />
            </div>
            <div className="text-xs uppercase tracking-[0.22em] text-ivory/50 mt-4">
              Forensic Accounting · Trial Law · Texas
            </div>
            <p className="mt-6 text-sm leading-relaxed max-w-md text-ivory/65">
              Forensic accounting and financially oriented legal matters.
              Fifty-plus years of business, family-law and probate litigation
              led by Richard L. Bufkin — attorney, CPA, and AICPA-certified
              forensic accountant.
            </p>
          </div>

          {/* Navigation */}
          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-gold mb-5">
              Navigate
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-ivory/75 hover:text-gold transition-colors link-underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="/richard-bufkin"
                  data-testid="footer-bio-link"
                  className="text-sm text-ivory/75 hover:text-gold transition-colors link-underline"
                >
                  Meet Dick Bufkin
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-gold mb-5">
              Contact
            </div>
            <ul className="space-y-3 text-sm text-ivory/75">
              <li>Richard L. Bufkin, CPA</li>
              <li>{FIRM.address.line1}</li>
              <li>{FIRM.address.line2}</li>
              <li className="pt-2">
                <a
                  href={`tel:${FIRM.phone.replace(/[^\d+]/g, "")}`}
                  className="hover:text-gold transition-colors"
                >
                  {FIRM.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${FIRM.email}`}
                  className="hover:text-gold transition-colors"
                >
                  {FIRM.email}
                </a>
              </li>
              <li className="pt-2">
                <a
                  href="https://share.google/BGUYnb28M1Yh89lcL"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-google-business"
                  className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-gold hover:text-gold-light transition-colors"
                >
                  Find us on Google →
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-ivory/10" />

        {/* Bottom row */}
        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-ivory/50">
            © {new Date().getFullYear()} The Bufkin Law Firm. All rights reserved.
          </p>
          <p className="text-xs text-ivory/40 italic max-w-md md:text-right">
            The information on this website is for general purposes only and
            does not constitute legal advice.
          </p>
        </div>
      </div>
    </footer>
  );
};
